import { Component, inject } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { DataService, feinbodenformFilter } from 'src/app/data.service';
import { bohrpunktNummerLabel, istPunktartMitNummer, trackByIndex, isM, generateMoorFBFSuggestions } from 'src/app/data-model';

@Component({
    standalone: false,
    selector: 'bp-kurzprotokoll',
    templateUrl: './kurzprotokoll.component.html',
    styleUrls: ['./hl-area.component.css'],

})
export class KurzprotokollComponent extends HlAreaComponent {
  ds: DataService = inject(DataService);

	istPunktartMitNummer = istPunktartMitNummer;
	trackByIndex = trackByIndex;
	bohrpunktNummerLabel = bohrpunktNummerLabel;
	feinbodenformFilter = feinbodenformFilter;
	moorFBFRegex = "^(ah|akah|kah|ih|akih|kih|vh|akvh|kvh|ph|akph|d|akd|kd|q|akq|kq|mk|k|im|akim|kim|vm|akvm)+(Ri|Fe|EF|Ml)\\.(R|K|M|MC|Z|ZC|A|AC|D)$";
	moorFBFRegexMessage = 'Moor-FBF: Substrat + Bodenform (Ri/Fe/EF/Ml) + . + Nährkraftstufe (R/K/M/Z/A/D, ggf. +C)';
	private _moorFBFSuggestions?: string[];
	get moorFBFSuggestions(): string[] {
		if (!this._moorFBFSuggestions) {
			this._moorFBFSuggestions = isM(this.data) ? generateMoorFBFSuggestions() : [];
		}
		return this._moorFBFSuggestions;
	}

  onNummerChanged(data: { previous: string, current: string }) {
    this.ds.nummerChanged.emit({ id: this.data._id, num: data.current });
  }

	punktartFilter() {
		return () => true;
	}

  addFeinbodenform() {
    this.data.header.bodenform.bf.push({ trenner: '/', hbf: '', fbf: ''});
  }

  removeFeinbodenform() {
    this.data.header.bodenform.bf.pop();
  }

  canAddFeinbodenform() {
    const bf = this.data.header.bodenform.bf;
    const l = bf.length;
    return l > 0 && l < 3 && (bf[l-1].hbf || bf[l-1].fbf);
  }
}
